var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"campaigns"},[_c('list',{attrs:{"data":{
            list: _vm.list,
            pagination: _vm.pagination,
            hasLoading: _vm.hasLoading,
            headers: [
                { type: 'default', value: 'beginDate' },
                { type: 'default', value: 'endDate' },
                { type: 'default', value: 'type' },
                {
                    type: 'component',
                    value: 'progress',
                    component: function () { return import( /* webpackChunkName: 'ProgressBar' */ '@/components/bundles/bars/progress/ProgressBar' ); }
                }, {
                    type: 'component',
                    translate: 'state',
                    value: 'id',
                    component: function () { return import( /* webpackChunkName: 'BaseStates' */ '@/components/bundles/states/BaseStates' ); }
                }
            ],
            destak: 'name',
            showId: true,
        }}}),_c('widget-options')],1)}
var staticRenderFns = []

export { render, staticRenderFns }